// @flow

import React, { Fragment } from 'react'

export type PropTypes = {
  options: Array<{
    name: string,
    description: string,
    priceText: string,
    priceUnitText: string,
  }>,
  open: boolean,
  onClickMoreView: Function,
}

const INITIAL_OPTION_VIEW = 3

export default (props: PropTypes) => (
  <div className="space-plan__option">
    <h3 className="space-plan__op-title">{i18n.t('page.room.option')}</h3>
    {props.options.map((option, i) => {
      if (!props.open && i >= INITIAL_OPTION_VIEW) return null

      return (
        <Fragment key={`plan_option_item_${i}`}>
          <dl className="space-plan__option-list">
            <dt className="space-plan__option-name">
              {i18n.t('page.room.optionName', { name: option.name })}
            </dt>
            <dd className="space-plan__option-price">
              {option.priceText}
              {(option.priceUnitText || '') && `/${option.priceUnitText}`}
            </dd>
          </dl>
          <p className="space-plan__option-memo">{option.description}</p>
        </Fragment>
      )
    })}
    {!props.open &&
      props.options.length > INITIAL_OPTION_VIEW && (
        <p className="space-plan__option-more" onClick={props.onClickMoreView}>
          {i18n.t('page.room.optionMoreView')}
          <i className="fa fa-angle-down ml5" />
        </p>
      )}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/PlanOptionList/index.jsx